import i18n from 'utils/i18n'
import { StyleSheet, Image, View } from 'react-native'
import { BlurView } from 'expo-blur'
import * as Haptics from 'expo-haptics'
import { navigationStyles } from 'navigations/_styles/styles'
import BottomNavigation, { BottomNavigationTab } from 'theme/BottomNavigation'
import _ from 'lodash'
import HelperString from 'utils/helper-string'
import { colorList } from 'utils/colors'
import React from 'react'
import { useSafeAreaInsets } from 'react-native-safe-area-context'
import AppIcon from 'assets/icon.png'
import HelperPlatform from 'utils/helper-platform'

const BottomTabBar = ({ props, tabs, onTabPress, vertical = false }) => {
	
	const insets = useSafeAreaInsets();
	
	const { routeNames, index } = props.state;
	const bottomInset = insets?.bottom ?? 0;
	// On iOS the floating pill can sit within the upper part of the home-indicator
	// safe area, leaving a 20pt gap on iPhones with a 34pt bottom inset.
	const bottomSpacing = HelperPlatform.isIOS()
		? Math.max( 8, bottomInset - 14 )
		: 8 + bottomInset;
	
	const showStyle = vertical ? {} : {
		paddingBottom: bottomSpacing
	}

	const onPress = ( tabIndex ) => {
		if( tabIndex !== index && !HelperPlatform.isWeb() ) {
			Haptics.selectionAsync().catch(() => {
			})
		}

		onTabPress( props, tabIndex );
	}

	const navigation = (
		<BottomNavigation
			vertical={ vertical }
			floating={ !vertical }
			selectedIndex={ index }
			style={ navigationStyles.bottomNavigation }
			indicatorStyle={ navigationStyles.bottomNavigationIndicator }>

			{ _.map( tabs, (tab, tabIndex) => {
				const isSelected = _.get( routeNames, index, null ) === tab.name;

				return (
					<BottomNavigationTab
						key={ HelperString.hash( 'HomeNavigator-TabNavigator-BottomTabBar', tab) }
						title={ tab.title }
						isSelected={ isSelected }
						vertical={ vertical }
						floating={ !vertical }
						icon={ () => {
							return tab.icon({
								style: {
									color: isSelected ? colorList.PRIMARY.dark : colorList.BLACK.light
								}
							});
						} }
						onPress={ onPress.bind( this, tabIndex ) }
					/>
				)
			})}
		</BottomNavigation>
	)
	
	return (
		<View
			style={ [
				navigationStyles.bottomNavigationContainer,
				vertical ? navigationStyles.bottomNavigationContainerVertical : null,
				showStyle
			] }>

			{ vertical && (
				<View style={ navigationStyles.appIconContainer }>
					<Image
						source={ AppIcon }
						style={ navigationStyles.appIcon }
						resizeMode="cover"
						accessible
						accessibilityLabel={ i18n.t( 'app_name' ) }
					/>
				</View>
			) }
			
			{ vertical ? navigation : (
				<View style={ navigationStyles.bottomNavigationFloatingShadow }>
					<BlurView
						intensity={ 48 }
						tint="light"
						blurMethod="none"
						style={[
							navigationStyles.bottomNavigationFloating,
							HelperPlatform.isAndroid() ? staticStyles.blurViewBackgroundColorRgba255255255095 : null,
						]}>
						<View
							pointerEvents="none"
							style={ navigationStyles.bottomNavigationHighlight }
						/>
						{ navigation }
					</BlurView>
				</View>
			) }
		</View>
	)
}

const staticStyles = StyleSheet.create({
	blurViewBackgroundColorRgba255255255095: {
		backgroundColor: 'rgba(255, 255, 255, 0.95)',
	},
});

export default BottomTabBar
